#import "../fragments/sales-automation-stageset.graphql"

mutation MoveStage($stage: StageUpdateInputFieldInput!) {
    stageUpdate(input: {stage: $stage}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
